import {CSSProperties} from "react";
import {LocalisedTypography} from "@components/localisation/LocalisedTypography";
import {EmailPasswordLogin} from "@components/authentication/EmailPasswordLogin";
import {EmailPasswordSignUp} from "@components/authentication/EmailPasswordSignUp";
import {GoogleSignIn} from "@components/authentication/GoogleSignIn";

interface IEmailPassword {
    onSuccess?: () => void
}

export function EmailPassword({onSuccess}: IEmailPassword) {
    const style: Record<string, CSSProperties> = {
        contents: {
            display: "flex",
            flexDirection: "column",
            margin: 4
        }
    };

    return (
        <div style={style.contents}>
            <h3>
                <LocalisedTypography content="AuthenticationGoogle"/>
            </h3>
            <GoogleSignIn/>
            <h3>
                <LocalisedTypography content="AuthenticationEmailPasswordLogin"/>
            </h3>
            <EmailPasswordLogin onSuccess={onSuccess}/>
            <h3>
                <LocalisedTypography content="AuthenticationEmailPasswordSignup"/>
            </h3>
            <EmailPasswordSignUp/>
        </div>
    );
}